export const ORIGIN_TABLE_MAP = {
  BulkStats: 'BulkStats',
  Candidates: 'Candidates',
  Companies: 'Companies',
  Contacts: 'Contacts',
  ResumeSearch: 'ResumeSearch',
  SearchProjectPreview: 'SearchProjectPreview'
};
